import {
    Container,
    Title,
    Text,
    SimpleGrid,
    Paper,
    Group,
    Button,
    Stack,
} from "@mantine/core";
import {
    IconMail,
    IconPhone,
    IconMapPin,
    IconBrandGithub,
    IconBrandLinkedin,
} from "@tabler/icons-react";
import { motion } from "framer-motion";
import classes from "./Contact.module.css";

const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
        opacity: 1,
        transition: {
            staggerChildren: 0.15,
        },
    },
};

const itemVariants = {
    hidden: { y: 30, opacity: 0 },
    visible: {
        y: 0,
        opacity: 1,
        transition: {
            type: "spring",
            stiffness: 100,
            damping: 12,
        },
    },
};

export function Contact({ data }) {
    return (
        <section className={classes.section} id='contact'>
            <Container size='lg'>
                <motion.div
                    initial={{ opacity: 0, y: 30 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true, amount: 0.3 }}
                    transition={{ duration: 0.6 }}>
                    <Title
                        order={2}
                        className={classes.title}
                        ta='center'
                        mb='xl'>
                        Kontakt
                    </Title>

                    <Text
                        size='lg'
                        ta='center'
                        mb={50}
                        c='dimmed'
                        maw={700}
                        mx='auto'>
                        Máte projekt nebo příležitost? Rád se s vámi spojím!
                    </Text>
                </motion.div>

                <motion.div
                    variants={containerVariants}
                    initial='hidden'
                    whileInView='visible'
                    viewport={{ once: true, amount: 0.2 }}>
                    <SimpleGrid
                        cols={{ base: 1, sm: 2, lg: 3 }}
                        spacing='xl'
                        mb='xl'>
                        <motion.div variants={itemVariants}>
                            <Paper p='xl' radius='md' className={classes.card}>
                                <Group mb='md'>
                                    <div className={classes.iconWrapper}>
                                        <IconMail size={24} />
                                    </div>
                                </Group>
                                <Title order={3} size='h5' mb='xs'>
                                    Email
                                </Title>
                                <Text
                                    size='sm'
                                    c='dimmed'
                                    component='a'
                                    href={`mailto:${data.personalInfo.email}`}>
                                    {data.personalInfo.email}
                                </Text>
                            </Paper>
                        </motion.div>

                        <motion.div variants={itemVariants}>
                            <Paper p='xl' radius='md' className={classes.card}>
                                <Group mb='md'>
                                    <div className={classes.iconWrapper}>
                                        <IconPhone size={24} />
                                    </div>
                                </Group>
                                <Title order={3} size='h5' mb='xs'>
                                    Telefon
                                </Title>
                                <Text size='sm' c='dimmed'>
                                    {data.personalInfo.phone}
                                </Text>
                            </Paper>
                        </motion.div>

                        <motion.div variants={itemVariants}>
                            <Paper p='xl' radius='md' className={classes.card}>
                                <Group mb='md'>
                                    <div className={classes.iconWrapper}>
                                        <IconMapPin size={24} />
                                    </div>
                                </Group>
                                <Title order={3} size='h5' mb='xs'>
                                    Lokace
                                </Title>
                                <Text size='sm' c='dimmed'>
                                    {data.personalInfo.location}
                                </Text>
                            </Paper>
                        </motion.div>
                    </SimpleGrid>
                </motion.div>

                <motion.div
                    initial={{ opacity: 0, y: 30 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true }}
                    transition={{ duration: 0.6, delay: 0.3 }}>
                    <Stack align='center' gap='md'>
                        <Text size='lg' fw={500}>
                            Můžete mě najít také zde:
                        </Text>
                        <Group gap='md'>
                            <Button
                                component='a'
                                href={data.social.github}
                                target='_blank'
                                rel='noopener noreferrer'
                                leftSection={<IconBrandGithub size={20} />}
                                variant='light'
                                size='lg'>
                                GitHub
                            </Button>
                            <Button
                                component='a'
                                href={data.social.linkedin}
                                target='_blank'
                                rel='noopener noreferrer'
                                leftSection={<IconBrandLinkedin size={20} />}
                                variant='light'
                                size='lg'>
                                LinkedIn
                            </Button>
                        </Group>
                    </Stack>
                </motion.div>
            </Container>
        </section>
    );
}
